import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DialogContainerComponent } from '@components/admin/configurator/dialog-container/dialog-container.component';
import { ButtonComponent } from '@components/shared/button/button.component';
import { SiteImporterData } from '@services/conversor.service';
import { catchError, distinctUntilChanged, map, of, startWith, switchMap, timer } from 'rxjs';
import { CommonModule } from '@angular/common';

interface SiteImporterResult {
  title: string;
  isCompatible: boolean;
  id: number;
}

interface SearchState {
  query: string;
  isLoading: boolean;
  results: SiteImporterResult[];
}

const emptySearchState: SearchState = {
  query: '',
  isLoading: false,
  results: []
};

@Component({
    selector: 'app-site-importer',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DialogContainerComponent,
        ButtonComponent
    ],
    templateUrl: './site-importer.component.html',
    styleUrls: ['./site-importer.component.css']
})
export class SiteImporterComponent {

  private readonly methods: SiteImporterData = inject<SiteImporterData>(DIALOG_DATA);

  readonly searchControl = new FormControl<string>('', { nonNullable: true });
  readonly searchState$ = this.searchControl.valueChanges.pipe(
    startWith(this.searchControl.value),
    map(query => query.trim()),
    distinctUntilChanged(),
    switchMap((query) => {
      if (query.length < 3) {
        return of({ ...emptySearchState, query });
      }

      return timer(300).pipe(
        switchMap(() => this.methods.onSearch(query)),
        map(response => ({
            query,
            isLoading: false,
            results: response.data ?? []
        })),
        startWith({
          query,
          isLoading: true,
          results: []
        }),
        catchError((error) => {
          console.error('Search error:', error);
          return of({
            query,
            isLoading: false,
            results: []
          });
        })
      );
    })
  );

  onImport(id: number, slug: string): void {
    this.methods.onStartConversion(id, slug);
  }
}
